var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQa({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    id: "Layer_1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5,22h13c0.55,0,1-0.45,1-1v-1c0-0.55-0.45-1-1-1s-1,0.45-1,1H6V4h6v5c0,0.55,0.45,1,1,1h4c0,0.55,0.45,1,1,1s1-0.45,1-1V9  c0-0.13-0.03-0.25-0.07-0.36c-0.02-0.04-0.04-0.08-0.07-0.12c-0.03-0.05-0.05-0.11-0.09-0.16l-5-6c-0.01-0.01-0.02-0.02-0.03-0.03  c-0.07-0.07-0.15-0.13-0.23-0.18c-0.03-0.02-0.06-0.05-0.1-0.06C13.28,2.03,13.15,2,13,2H5C4.45,2,4,2.45,4,3v18  C4,21.55,4.45,22,5,22z M14,5.76L15.87,8H14V5.76z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8,10h2c0.55,0,1-0.45,1-1s-0.45-1-1-1H8C7.45,8,7,8.45,7,9S7.45,10,8,10z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14,11H8c-0.55,0-1,0.45-1,1s0.45,1,1,1h6c0.55,0,1-0.45,1-1S14.55,11,14,11z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8,16h4c0.55,0,1-0.45,1-1s-0.45-1-1-1H8c-0.55,0-1,0.45-1,1S7.45,16,8,16z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8,19h6c0.55,0,1-0.45,1-1s-0.45-1-1-1H8c-0.55,0-1,0.45-1,1S7.45,19,8,19z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.71,16.29C20.7,16.29,20.7,16.29,20.71,16.29C20.89,15.9,21,15.46,21,15c0-1.66-1.34-3-3-3s-3,1.34-3,3s1.34,3,3,3  c0.46,0,0.9-0.11,1.29-0.3c0,0,0,0.01,0.01,0.01l1,1C20.49,18.9,20.74,19,21,19s0.51-0.1,0.71-0.29c0.39-0.39,0.39-1.02,0-1.41  L20.71,16.29z M18,16c-0.55,0-1-0.45-1-1s0.45-1,1-1s1,0.45,1,1S18.55,16,18,16z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQa);
export default __webpack_public_path__ + "static/media/qa.ac573a12767fd66cd37cd60d63436e92.svg";
export { ForwardRef as ReactComponent };